"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButtons = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var isAction = function (a) {
    return typeof a[1] === "function";
};
var ActionButtons = function (_a) {
    var _b, _c;
    var _d = _a.actions, firstAction = _d[0], actionsArray = _d.slice(1), data = _a.data, _e = _a.size, size = _e === void 0 ? "middle" : _e, _f = _a.dropdownOnly, dropdownOnly = _f === void 0 ? false : _f, dropdownProps = _a.dropdownProps;
    var restArray = dropdownOnly
        ? __spreadArray([firstAction], actionsArray) : actionsArray;
    var filteredArray = restArray.filter(function (a) { var _a, _b, _c; return !((_a = a[2]) === null || _a === void 0 ? void 0 : _a.cond) ? true : (_c = (_b = a[2]) === null || _b === void 0 ? void 0 : _b.cond) === null || _c === void 0 ? void 0 : _c.call(_b, data); });
    return (react_1.default.createElement("div", { style: { display: "flex", flexDirection: "row" } },
        !dropdownOnly && firstAction && (react_1.default.createElement(antd_1.Button, { danger: (_b = firstAction === null || firstAction === void 0 ? void 0 : firstAction[2]) === null || _b === void 0 ? void 0 : _b.danger, onClick: function () { var _a; return (_a = firstAction) === null || _a === void 0 ? void 0 : _a[1](data); }, size: size, disabled: (_c = firstAction === null || firstAction === void 0 ? void 0 : firstAction[2]) === null || _c === void 0 ? void 0 : _c.disabled }, firstAction === null || firstAction === void 0 ? void 0 : firstAction[0])),
        !!filteredArray.length && (react_1.default.createElement(antd_1.Dropdown, __assign({}, dropdownProps, { trigger: ["hover"], overlay: react_1.default.createElement(antd_1.Menu, null, filteredArray === null || filteredArray === void 0 ? void 0 : filteredArray.map(function (action, index) {
                var _a, _b;
                return (react_1.default.createElement(react_1.default.Fragment, null, isAction(action) ? (react_1.default.createElement(antd_1.Menu.Item
                /* eslint-disable-next-line react/no-array-index-key */
                , { 
                    /* eslint-disable-next-line react/no-array-index-key */
                    key: index, onClick: function () { return action === null || action === void 0 ? void 0 : action[1](data); }, danger: (_a = action === null || action === void 0 ? void 0 : action[2]) === null || _a === void 0 ? void 0 : _a.danger, disabled: (_b = firstAction === null || firstAction === void 0 ? void 0 : firstAction[2]) === null || _b === void 0 ? void 0 : _b.disabled },
                    react_1.default.createElement("div", { style: {
                            minWidth: "100px",
                            width: "auto",
                        } }, action === null || action === void 0 ? void 0 : action[0]))) : (react_1.default.createElement(antd_1.Menu.ItemGroup, { title: action[0] }, action[1].map(function (act, subIndex) {
                    var _a, _b;
                    return (react_1.default.createElement(antd_1.Menu.Item
                    /* eslint-disable-next-line react/no-array-index-key */
                    , { 
                        /* eslint-disable-next-line react/no-array-index-key */
                        key: index + "_" + subIndex, onClick: function () { return act === null || act === void 0 ? void 0 : act[1](data); }, danger: (_a = act === null || act === void 0 ? void 0 : act[2]) === null || _a === void 0 ? void 0 : _a.danger, disabled: (_b = firstAction === null || firstAction === void 0 ? void 0 : firstAction[2]) === null || _b === void 0 ? void 0 : _b.disabled },
                        react_1.default.createElement("div", { style: {
                                minWidth: "100px",
                                width: "auto",
                            } }, act === null || act === void 0 ? void 0 : act[0])));
                })))));
            })) }),
            react_1.default.createElement(antd_1.Button, { size: size, type: "text" },
                react_1.default.createElement(icons_1.MoreOutlined, null))))));
};
exports.ActionButtons = ActionButtons;
